import { useEffect, useState } from 'react';

const decode = (value, unwrap) => !unwrap ? value || null
  : value?.status && value.status !== 'complete' ? null : value?.result
    ? { ...value.result, credit: value.credit, meta: value.meta } : value || null;

export default function useRunResult(incoming, unwrap = false) {
  const [result, setResult] = useState(() => decode(incoming, unwrap));
  useEffect(() => { setResult(decode(incoming, unwrap)); }, [incoming, unwrap]);
  return [result, (value) => setResult(decode(value, unwrap))];
}
